import styled from '@emotion/styled';

import { Text } from '../text';

export const CalloutBox = styled.div`
  border-radius: 10px;
  background: linear-gradient(
    90.09deg,
    rgba(197, 235, 235, 0.5) 0.08%,
    rgba(208, 243, 220, 0.5) 99.93%
  );
  padding: 15px 20px;
`;

export const CalloutHeader = styled(Text)``;

CalloutHeader.defaultProps = {
  bold: true,
  color: 'darkBendBlue',
  variant: 'text5',
};
